import styled, { css } from "styled-components";

import { BorderBottomLinkStyle, CustomFocusStyle } from "core/Typography";
import BodyText from "core/BodyText";
import colors from "core/colors";
import breakpoints from "core/breakpoints";
import { rapidEasing } from "core/animation";
import { convertPxToRem } from "frontend/components/helpers";

const LinkStyle = css`
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-color: ${colors.accent.darkMode.suenosBuenos};
    transition: color ${rapidEasing}, border-bottom-color ${rapidEasing};
    &:hover {
        color: ${colors.primary.diamond};
        border-color: ${colors.primary.diamond};
    }
    ${CustomFocusStyle}
`;

export const Link = styled.a`
    ${LinkStyle}
`;

export const Button = styled.button`
    background: none;
    border: none;
    padding: 0;
    ${LinkStyle}
`;

export const Divider = styled.div`
    width: 100%;
    background-color: ${colors.secondary.basalt};
    height: ${convertPxToRem({ px: 1 })};
    margin-top: ${convertPxToRem({ px: 24 })};
    margin-bottom: ${convertPxToRem({ px: 24 })};

    @media (min-width: ${breakpoints.tablet.rem}) {
        margin-top: ${convertPxToRem({ px: 32 })};
        margin-bottom: ${convertPxToRem({ px: 32 })};
    }
`;

export const SecondaryText = styled.span`
    margin-left: ${convertPxToRem({ px: 8 })};
    margin-top: ${convertPxToRem({ px: 8 })};
    margin-bottom: ${convertPxToRem({ px: 24 })};
    color: ${colors.secondary.dolphin};
`;

export const PublicDomainMessageSection = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
`;

export const IconDetailsText = styled.p`
    display: block;
    margin-bottom: ${convertPxToRem({ px: 8 })};
`;
